import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { Layout } from "@/components/Layout";
import { ProtectedRoute } from "@/components/ProtectedRoute";

import Home from "@/pages/Home";
import Services from "@/pages/Services";
import ServiceDetail from "@/pages/ServiceDetail";
import About from "@/pages/About";
import ServiceAreas from "@/pages/ServiceAreas";
import AreaDetail from "@/pages/AreaDetail";
import Careers from "@/pages/Careers";
import JobDetail from "@/pages/JobDetail";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Resources from "@/pages/Resources";
import Contact from "@/pages/Contact";
import Payments from "@/pages/Payments";
import Accessibility from "@/pages/Accessibility";
import Privacy from "@/pages/Privacy";
import FindUs from "@/pages/FindUs";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";

const Site = ({ children }) => <Layout>{children}</Layout>;

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Site><Home /></Site>} />
          <Route path="/services" element={<Site><Services /></Site>} />
          <Route path="/services/:slug" element={<Site><ServiceDetail /></Site>} />
          <Route path="/about" element={<Site><About /></Site>} />
          <Route path="/service-areas" element={<Site><ServiceAreas /></Site>} />
          <Route path="/service-areas/:slug" element={<Site><AreaDetail /></Site>} />
          <Route path="/careers" element={<Site><Careers /></Site>} />
          <Route path="/careers/:slug" element={<Site><JobDetail /></Site>} />
          <Route path="/resources" element={<Site><Resources /></Site>} />
          <Route path="/blog" element={<Navigate to="/resources" replace />} />
          <Route path="/blog/:slug" element={<Site><BlogPost /></Site>} />
          <Route path="/contact" element={<Site><Contact /></Site>} />
          <Route path="/payments" element={<Site><Payments /></Site>} />
          <Route path="/accessibility" element={<Site><Accessibility /></Site>} />
          <Route path="/privacy" element={<Site><Privacy /></Site>} />
          <Route path="/find-us" element={<Site><FindUs /></Site>} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </AuthProvider>
  );
}

export default App;
